<section class="relative px-[1.25rem] py-[1.5rem]">
  <p-button icon="true"
            severity="contrast"
            rounded="true"
            class="absolute right-[1rem] top-[1rem] flex"
            styleClass="!size-[1.75rem] !px-0 !py-0 !bg-transparent !text-(--p-primary-200) hover:!text-(--p-primary-500) focus:!text-(--p-primary-500) !border-0"
            [text]="true"
            [ariaLabel]="'@@shared-close' | translate"
            (onClick)="close()">
    <svg-icon src="icons/icon-close-popup.svg" name="icon-close-popup"></svg-icon>
  </p-button>

  <div class="flex items-center gap-[0.625rem] pr-[2rem]">
    <svg-icon src="icons/icon-delete.svg"
              name="icon-delete"
              class="block size-[1.25rem] shrink-0 text-(--p-primary-500)"></svg-icon>

    <h3 class="text-[1rem] font-semibold leading-[150%] text-(--p-primary-500)">{{ '@@dialog-delete-event__title' | translate }}</h3>
  </div>
  <p class="mt-[0.75rem] whitespace-pre-line text-[0.75rem] leading-[150%] text-(--p-gray-950)">
    {{ bodyBefore }}
    <strong class="font-semibold">
      {{ serialNo }}
    </strong>
    {{ bodyAfter }}
  </p>

  <div class="mt-[1.5rem] flex items-center justify-end gap-[0.25rem]">
    <p-button [outlined]="true"
              styleClass="!h-[2rem] !px-[1.25rem] !rounded-[0.25rem] !border-(--p-primary-500) !text-(--p-primary-500)"
              [label]="'@@shared-cancel__text' | translate"
              (onClick)="close()"></p-button>

    <p-button styleClass="!h-[2rem] !px-[1.25rem] !rounded-[0.25rem]"
              [label]="'@@dialog-delete-event__confirm' | translate"
              (onClick)="close(true)"></p-button>
  </div>
</section>
